import AbstractGroupItem from '../item/abstractGroupItem';
import ValidationResult from './validationResult';

/**
 * @class AbstractValidator
 * @extends EventEmitter
 */
export default class AbstractValidator {
    problemFactory = null;

    /**
     * @param {ProblemFactory} problemFactory
     */
    constructor(problemFactory) {
        this.problemFactory = problemFactory;
    }

    /**
     * @param {AbstractItem} item
     * @return {ValidationResult[]}
     */
    validateItem(item) {
        if (item instanceof AbstractGroupItem) {
            const items = item.resolveGroupItems();
            return [new ValidationResult(this, items, this._validateItems(items))];
        }

        return [new ValidationResult(this, [item], this._validateSingleItem(item))];
    }

    /**
     * Validates a single non-group item
     * @param {AbstractItem} item
     * @return {AbstractProblem[]}
     * @private
     */
    _validateSingleItem(item) {
        if (this._isItemSupported(item) && !this._isItemValid(item)) {
            return this._createProblems(item);
        }

        return [];
    }

    /**
     * Validates all items in a group, recursive
     *
     * @param {AbstractItem[]} items
     * @return {AbstractProblem[]}
     * @protected
     */
    _validateItems(items) {
        return items
            .map(child => this._validateSingleItem(child))
            .reduce((flattened, problems) => flattened.concat(problems), []);
    }

    /**
     * @param {AbstractItem} item
     * @return {boolean}
     * @abstract
     * @protected
     */
    _isItemSupported(item) { // eslint-disable-line no-unused-vars
        return true;
    }

    /**
     * @param {AbstractItem} item
     * @return {boolean}
     * @abstract
     * @protected
     */
    _isItemValid(item) { // eslint-disable-line no-unused-vars
        return true;
    }

    /**
     * @param {AbstractItem} item
     * @return {AbstractProblem[]}
     * @abstract
     * @protected
     */
    _createProblems(item) { // eslint-disable-line no-unused-vars
        return [];
    }
}
